__turbopack_context__.v({
  "actions": "status-screen-module-scss-module__dMzdJW__actions",
  "eyebrow": "status-screen-module-scss-module__dMzdJW__eyebrow",
  "root": "status-screen-module-scss-module__dMzdJW__root",
  "text": "status-screen-module-scss-module__dMzdJW__text",
  "title": "status-screen-module-scss-module__dMzdJW__title",
});
